/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React, {useState} from 'react';

/* APP / CONTEXTOS */

import EntidadesController from "../../servicos/entidades/EntidadesController.ts";
import {IRetornoAjaxEntidades, IEntidadesData} from "../../servicos/entidades/Entidades_FrontAPI.ts";

/* COMPONENTES */

import LoadingSkeleton from '../../componentes/tabelas/LoadingSkeleton.tsx';
import AlertDialog, { IAlertConfirmDelegate } from '../../componentes/widgets/AlertConfirm.tsx';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha.tsx';
import { IPropsFilterObj, objFilterDefault } from '../../componentes/tabelas/TableFilter.tsx';

/* INTERFACES / ENUMERAÇÕES */

import FormDialog from './formDialog.tsx';
import ListComponent from '../../componentes/lists/_ListComponent.tsx';
import {EFORM} from '../../componentes/formularios/EFORM';

import { ETABLE, ITablePaginacao } from '../../componentes/tabelas/ITabelas.ts';
import { isNumber } from 'lodash';
import { IFormStateEntidades } from 'src/servicos/IFormularios.ts';
import { useNavigate } from 'react-router-dom';
import { useAppContextoReact } from '../../../src/servicos/app/AppContextoReact.tsx';

interface IPageContexto
{
	_handleAdd?: any
	_handleEdit?: any
	_handleView?: any
	_handleExclude?: any
}

const PageContext = React.createContext<IPageContexto|undefined>(undefined);

const ListaRepositorio = () =>
{

	const appContext = useAppContextoReact();
	const EntController = new EntidadesController();
    
	const [ehCarregado, setEhCarregado] = useState<boolean>(false);
	const [deleting, setDeleting] = useState<boolean>(false);
	const [bananinhaDelegate, setBananinhaDelegate] = useState<IBananinhaDelegate|undefined>(undefined);
	const [alertConfirmDelegate, setAlertConfirmDelegate] = useState<IAlertConfirmDelegate|undefined>(undefined);
	const [listaPaginada, setListaPaginada] = useState<IEntidadesData[]|null>(null);
	const [openDialog, setOpenDialog] = React.useState(false);

	const [formEntidade, setFormEntidade] = React.useState<IFormStateEntidades>(null);
	const [formView, setFormView] = React.useState<boolean>(false);

	const [pager, setPager] = useState<ITablePaginacao|null>(null);
	const [pageNumber, setPageNumber] = React.useState<number>();
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(20);
	const [dataFilter, setDataFilter] = React.useState<IPropsFilterObj>(objFilterDefault);
	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);
	const navigate = useNavigate();

	React.useEffect(() =>
	{
		const isAdmin = appContext.permissao.administrador
		setUserRolerAdmin(isAdmin)
		!isAdmin ? navigate('/lista-programas') : ''
	},[appContext])
	
	const _handleAdd = () =>
	{
		const entidade: IFormStateEntidades = { programas: [] }
		setFormEntidade(entidade);
		setOpenDialog(true);
		setFormView(false);
	}
	const _handleEdit = (entidade:IFormStateEntidades) =>
	{
		setFormEntidade(entidade);
		setOpenDialog(true);
		setFormView(false);
	}
	const _handleView = (entidade:IFormStateEntidades) =>
	{
		setFormEntidade(entidade);
		setOpenDialog(true);
		setFormView(true);
	}

	React.useEffect(() =>
	{
		setFormEntidade(formEntidade)
	},[formEntidade])

	const _delete = React.useCallback( async (ID: string) => 
	{
		setDeleting(true);
		setEhCarregado(false);
		try
		{
			const res:IRetornoAjaxEntidades = await EntController.repositorioDelete(ID);
			if (res && res.status == 200)
			{
				// Se página atual = última página e só tem 1 item na página
				if (isNumber(pageNumber) && isNumber(rowsPerPage) && pageNumber == pager.total_pages && ((pager.total_items % rowsPerPage) == 1 )) {
					setPageNumber(Math.max(1, pageNumber - 1))
				}
				bananinhaDelegate?.abrir("Item excluído com sucesso.", "success");
			}
			else
			{
				setEhCarregado(true);
				bananinhaDelegate?.abrir(res.message, "error");
			}
		}
		catch(e)
		{
			setEhCarregado(true);
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			setDeleting(false);
		}
		return '';
	}, [bananinhaDelegate, pageNumber, pager, rowsPerPage]);
	const _handleExclude = React.useCallback((ID: string, Name: string) =>
	{
		alertConfirmDelegate?.abrir(
			"Confirme a exclusão", 
			'Deseja realmente excluir o item "' + Name + '"?',  
			(bln:any) => 
			{
				if(bln) _delete(ID)
			}
		)
	}, [alertConfirmDelegate, _delete])
	React.useEffect(() =>
	{
		if(!deleting)
		{
			getList()
		}
	},[deleting])

	const getList = async (callbackDataFilter?:IPropsFilterObj, rowsNum?:number, pageNum?:number) =>
	{
		try
		{
			setEhCarregado(false);
			const res:IRetornoAjaxEntidades = await EntController.repositorioList(undefined, callbackDataFilter || dataFilter, rowsNum || rowsPerPage, pageNum || pageNumber);
			if (res.Data?.rows) {
				if (res.Data?.rows?.length > 0)
				{
					setListaPaginada(res.Data?.rows);
					if (res?.pager)
					{
						setPager(res?.pager);
						setPageNumber(res.pager.current_page);
						setRowsPerPage(res.pager.items_per_page);
					}
				}
				else
				{
					setListaPaginada([]);
					setPager(null);
					setPageNumber(1);
					bananinhaDelegate?.abrir('Nenhum resultado encontrado.', "error");
				}
			}
		}
		catch(e)
		{
			bananinhaDelegate?.abrir(e, "error");
		}
		finally
		{
			setEhCarregado(true);
		}
	}

	return <>
		<PageContext.Provider value={{ _handleAdd: _handleAdd, _handleEdit: _handleEdit, _handleExclude: _handleExclude, _handleView: _handleView }}>
			<Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
			<AlertDialog getDelegate={delegate => alertConfirmDelegate ?? setAlertConfirmDelegate(delegate)}/>
			{(ehCarregado && listaPaginada && !deleting) ?
				<PageContext.Consumer>{ctx => (
					<ListComponent 
						titulo="Repositórios"
						addHandleAdd={() => ctx?._handleAdd()}
						addUrl={null}
						addEhNovaJanela={null}
						lstTipo={ETABLE.REPOSITORIO}
						lstListaPaginada={listaPaginada}
						lstPaginacao={pager}
						lstPageNumber={pageNumber}
						lstRowsPerPage={rowsPerPage}
						lstSetup={[
							// { id: 'idRepositorio',	numeric: false,	label: 'ID' },
							{ id: 'nome',			numeric: false,	label: 'Nome',			sort: false,	align: 'left' },
							{ id: 'bucket',			numeric: false,	label: 'Bucket',		sort: false,	align: 'left' },
							{ id: 'diretorio',		numeric: false,	label: 'Repositório',	sort: false,	align: 'left' },
							{ id: 'dataCadastro',	numeric: false,	label: 'Cadastrado em',	sort: false },
							{ id: 'dataAlteracao',	numeric: false,	label: 'Alterado em',	sort: false }
						]}
						lstHandleEdit={(props) => ctx?._handleEdit(props)}
						lstHandleView={(props) => ctx?._handleView(props)}
						lstHandleDelete={(id, name) => ctx?._handleExclude(id, name)}
						lstFieldID="idRepositorio"
						lstFieldName="diretorio"
						lstCallback={async (rowsNum, pageNum) => 
							{
							setEhCarregado(false);
							setRowsPerPage(rowsNum);
							setPageNumber(pageNum);
							await getList(undefined, rowsNum, pageNum);
							}}
					>
						<></>
					</ListComponent>
				)}</PageContext.Consumer>
			:
				<LoadingSkeleton columns={6} />
			}
			{
				formEntidade &&
					<FormDialog
						operacao={formEntidade.idRepositorio ? EFORM.UPDATE : EFORM.ADD}
						entidade={formEntidade}
						setEntidade={setFormEntidade}
						openDialog={openDialog}
						listViews={formView}
						setOpenDialog={setOpenDialog}
						callBack={() => 
						{
							setEhCarregado(false);
							getList();
						}}
					/>
			}
		</PageContext.Provider>
	</>
}
export default ListaRepositorio;
